module.exports = __webpack_public_path__ + "img/logo-screen.cdec7c4e.png";